/**
 * FRONT-1507: the header carrying the reader's own device timezone on every
 * request, so the server can convert timestamps into their local clock.
 *
 * Resolution mirrors the existing precedent at `routes/onboard.tsx`'s
 * `saveSilentDefaults` (`Intl.DateTimeFormat().resolvedOptions().timeZone`),
 * memoized here since it never changes within a page session and every
 * request would otherwise re-resolve it.
 */
export const TIMEZONE_HEADER = "X-EDDY-Timezone";

let cached: string | undefined;
let resolved = false;

export function deviceTimezone(): string | undefined {
  if (!resolved) {
    resolved = true;
    try {
      cached = Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
    } catch {
      cached = undefined;
    }
  }
  return cached;
}

/**
 * `{}` when the zone can't be resolved, so every call site can spread this
 * unconditionally without an `if` guard.
 */
export function timezoneHeader(): Record<string, string> {
  const tz = deviceTimezone();
  return tz ? { [TIMEZONE_HEADER]: tz } : {};
}
